import { h } from 'vue'
import OrganismSecurity from '~/components/organisms/security/security.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(UiComponentContainer, { class: 'security-badges' }, () => [
    h(OrganismSecurity, {
      badges: props.record.isLocalized
        ? props.record.content.badges
        : props.componentSecurityBadges.badges,
    }, {
      title: () =>
        props.record.isLocalized
          ? props.record.content.title
          : props.componentSecurityBadges.title,
      description: () =>
        props.record.isLocalized
          ? props.record.content.description
          : props.componentSecurityBadges.description,
    }),
  ])
}

Functional.props = {
  componentSecurityBadges: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
